<template>
  <div>
    <el-checkbox v-model="showInactive" @change="fetchPresets"
      >Показать отключённые</el-checkbox
    >

    <div v-loading="loading" class="preset-list">
      <el-card
        v-for="(preset, index) in presets"
        :key="preset._id || `new-${index}`"
        shadow="hover"
        class="preset-card"
        :class="{ 'preset-card--inactive': !preset.isActive }"
      >
        <div class="preset-card__header">
          <el-autocomplete
            v-model="preset.name"
            :fetch-suggestions="querySearchName"
            placeholder="Подкатегория"
            size="small"
            class="preset-card__name"
          ></el-autocomplete>
          <el-select
            v-model="preset.giveKey"
            filterable
            size="small"
            placeholder="Отдаёт"
            class="preset-card__pair-select"
          >
            <el-option
              v-for="v in dedupedValutes"
              :key="v.key"
              :label="v.displayLabel"
              :value="v.key"
            ></el-option>
          </el-select>
          <i class="el-icon-right"></i>
          <el-select
            v-model="preset.getKey"
            filterable
            size="small"
            placeholder="Получает"
            class="preset-card__pair-select"
          >
            <el-option
              v-for="v in dedupedValutes"
              :key="v.key"
              :label="v.displayLabel"
              :value="v.key"
            ></el-option>
          </el-select>
          <el-tag v-if="!preset.isActive" type="info" size="mini">отключён</el-tag>
          <span class="preset-card__spacer"></span>
          <el-button
            v-if="preset._id"
            icon="el-icon-time"
            circle
            size="mini"
            title="Журнал изменений"
            @click="openHistory(preset)"
          ></el-button>
          <el-button
            v-if="preset._id && preset.isActive"
            icon="el-icon-delete"
            circle
            size="mini"
            type="danger"
            title="Отключить"
            @click="deactivate(preset)"
          ></el-button>
        </div>

        <div class="preset-card__ranges">
          <div class="preset-card__ranges-hint">
            Границы диапазонов — всегда в рублях, независимо от валют пары.
          </div>
          <div v-for="(r, i) in preset.ranges" :key="i" class="range-row">
            <span>От</span>
            <el-input-number v-model="r.from" :controls="false" size="small"></el-input-number>
            <span>до</span>
            <el-input v-model="r.to" placeholder="∞" size="small" class="range-row__to"></el-input>
            <span>₽</span>
            <el-select v-model="r.type" size="small" class="range-row__type">
              <el-option label="%" value="percent"></el-option>
              <el-option label="Фикс, ₽" value="fixed"></el-option>
            </el-select>
            <el-input-number v-model="r.value" :controls="false" size="small"></el-input-number>
            <el-tooltip
              content="Безусловный тариф — флэт-вычет в валюте отдачи поверх процента/фикса. В большинстве случаев 0, нужен только для отсечения слишком маленьких сумм у отдельных пар (как BTC-BTC в референсе)."
              placement="top"
            >
              <span class="range-row__fee-label">+ {{ preset.giveKey || "?" }}</span>
            </el-tooltip>
            <el-input-number
              v-model="r.extraGiveFee"
              :controls="false"
              :precision="8"
              size="small"
            ></el-input-number>
            <el-button
              icon="el-icon-close"
              circle
              size="mini"
              @click="preset.ranges.splice(i, 1)"
            ></el-button>
          </div>
          <el-button size="mini" @click="addRangeTo(preset)">+ Добавить диапазон</el-button>
        </div>

        <div class="preset-card__actions" v-if="isDirty(preset)">
          <el-button
            type="primary"
            size="mini"
            :loading="savingKey === (preset._id || presetKey(preset, index))"
            @click="save(preset)"
            >{{ preset._id ? "Сохранить" : "Создать" }}</el-button
          >
          <el-button size="mini" @click="revert(preset, index)">Отменить</el-button>
        </div>
      </el-card>
    </div>

    <el-button class="new-preset-btn" @click="addNewPreset">+ Создать новый пресет</el-button>

    <el-dialog title="Журнал изменений" :visible.sync="historyVisible" width="600px" append-to-body>
      <div v-if="historyEntries.length === 0">Пока нет записей</div>
      <div v-for="h in historyEntries" :key="h._id" class="history-entry">
        <div>
          <strong>{{ $dayjs(h.dt).format("DD.MM.YYYY HH:mm:ss") }}</strong>
          — {{ (h.changedBy && h.changedBy.login) || "неизвестно кем" }}
        </div>
        <div class="history-diff">
          <div>До: {{ h.before ? JSON.stringify(h.before) : "—" }}</div>
          <div>После: {{ h.after ? JSON.stringify(h.after) : "—" }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getValutes,
  getCommissionPresets,
  createCommissionPreset,
  updateCommissionPreset,
  deleteCommissionPreset
} from "@/api";
import { dedupeValutesByKey } from "@/utils/valutes";

const newRange = () => ({
  from: 0,
  to: null,
  type: "percent",
  value: 0,
  extraGiveFee: 0
});

export default {
  name: "LedgerCommissionPresetsComponent",
  data: () => ({
    loading: false,
    savingKey: null,
    presets: [],
    originalById: {},
    valutes: [],
    showInactive: false,
    historyVisible: false,
    historyEntries: []
  }),
  computed: {
    // См. dedupeValutesByKey в @/utils/valutes — общий дедуп-по-key с
    // TRC20 как канонической записью для USDT (та же логика, что и в
    // CommissionCalculatorModal.vue).
    dedupedValutes() {
      return dedupeValutesByKey(this.valutes);
    }
  },
  methods: {
    presetKey(preset, index) {
      return preset._id || `new-${index}`;
    },
    snapshot(preset) {
      return JSON.stringify({
        giveKey: preset.giveKey,
        getKey: preset.getKey,
        name: preset.name,
        ranges: preset.ranges
      });
    },
    isDirty(preset) {
      if (!preset._id) return true;
      const original = this.originalById[preset._id];
      if (!original) return true;
      return this.snapshot(preset) !== this.snapshot(original);
    },
    async fetchPresets() {
      this.loading = true;
      try {
        const { data } = await getCommissionPresets({
          includeInactive: this.showInactive ? "true" : undefined
        });
        if (data.status) {
          this.presets = data.result.map(p => ({
            ...p,
            ranges: p.ranges.map(r => ({ ...r }))
          }));
          this.originalById = {};
          this.presets.forEach(p => {
            this.originalById[p._id] = JSON.parse(JSON.stringify(p));
          });
        }
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchValutes() {
      try {
        const { data } = await getValutes();
        if (data.status) this.valutes = data.result;
      } catch (error) {
        this.handleResponseError(error);
      }
    },
    querySearchName(queryString, cb) {
      const names = [...new Set(this.presets.map(p => p.name).filter(Boolean))];
      const results = (queryString
        ? names.filter(n => n.toLowerCase().includes(queryString.toLowerCase()))
        : names
      ).map(value => ({ value }));
      cb(results);
    },
    addRangeTo(preset) {
      const last = preset.ranges[preset.ranges.length - 1];
      preset.ranges.push({
        from: last && last.to !== null && last.to !== "" ? last.to : 0,
        to: null,
        type: "percent",
        value: 0,
        extraGiveFee: 0
      });
    },
    addNewPreset() {
      this.presets.push({
        _id: null,
        giveKey: null,
        getKey: null,
        name: "",
        ranges: [newRange()],
        isActive: true,
        history: []
      });
    },
    revert(preset, index) {
      if (!preset._id) {
        this.presets.splice(index, 1);
        return;
      }
      const original = this.originalById[preset._id];
      const restored = JSON.parse(JSON.stringify(original));
      this.presets.splice(index, 1, restored);
    },
    // "from"/"value" — el-input-number, уже числа. "to" — обычный el-input
    // (строка или null): у el-input-number нет понятия "пусто", при null он
    // молча подставляет 0 прямо на рендере — открытый диапазон стал бы
    // неотличим от диапазона с границей 0.
    normalizeRanges(ranges) {
      return ranges.map(r => {
        const toEmpty = r.to === null || r.to === undefined || r.to === "";
        const to = toEmpty ? null : Number(r.to);
        if (!toEmpty && !Number.isFinite(to)) {
          throw new Error(`Диапазон: некорректное значение «до» (${r.to})`);
        }
        if (!Number.isFinite(Number(r.from))) {
          throw new Error(`Диапазон: некорректное значение «от» (${r.from})`);
        }
        if (!Number.isFinite(Number(r.value))) {
          throw new Error("Диапазон: некорректное значение суммы/процента");
        }
        const extraGiveFee = r.extraGiveFee === "" || r.extraGiveFee === null || r.extraGiveFee === undefined
          ? 0
          : Number(r.extraGiveFee);
        if (!Number.isFinite(extraGiveFee)) {
          throw new Error("Диапазон: некорректное значение безусловного тарифа");
        }
        return {
          from: Number(r.from),
          to,
          type: r.type,
          value: Number(r.value),
          extraGiveFee
        };
      });
    },
    async save(preset) {
      if (!preset.giveKey || !preset.getKey) {
        return this.$message({ type: "error", message: "Выберите обе валюты пары" });
      }
      if (!preset.name || !preset.name.trim()) {
        return this.$message({ type: "error", message: "Введите название подкатегории" });
      }
      if (!preset.ranges.length) {
        return this.$message({ type: "error", message: "Нужен хотя бы один диапазон" });
      }
      let ranges;
      try {
        ranges = this.normalizeRanges(preset.ranges);
      } catch (error) {
        return this.$message({ type: "error", message: error.message });
      }
      const index = this.presets.indexOf(preset);
      this.savingKey = this.presetKey(preset, index);
      try {
        const payload = {
          giveKey: preset.giveKey,
          getKey: preset.getKey,
          name: preset.name.trim(),
          ranges
        };
        const { data } = preset._id
          ? await updateCommissionPreset(preset._id, payload)
          : await createCommissionPreset(payload);
        if (data.status) {
          this.$message({ type: "success", message: "Сохранено" });
          await this.fetchPresets();
        }
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.savingKey = null;
      }
    },
    async deactivate(preset) {
      try {
        await this.$confirm(
          `Отключить пресет «${preset.name}» (${preset.giveKey} → ${preset.getKey})?`,
          "Внимание!",
          { confirmButtonText: "Отключить", cancelButtonText: "Отменить", type: "warning" }
        );
      } catch (error) {
        return;
      }
      try {
        await deleteCommissionPreset(preset._id);
        this.$message({ type: "success", message: "Пресет отключён" });
        await this.fetchPresets();
      } catch (error) {
        this.handleResponseError(error);
      }
    },
    openHistory(preset) {
      this.historyEntries = [...(preset.history || [])].reverse();
      this.historyVisible = true;
    }
  },
  async mounted() {
    await Promise.all([this.fetchPresets(), this.fetchValutes()]);
  }
};
</script>
<style scoped>
.preset-list {
  min-height: 40px;
}
.preset-card {
  margin-bottom: 12px;
}
.preset-card--inactive {
  opacity: 0.6;
}
.preset-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.preset-card__name {
  width: 160px;
}
.preset-card__pair-select {
  width: 130px;
}
.preset-card__spacer {
  flex: 1;
}
.preset-card__ranges {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}
.preset-card__ranges-hint {
  color: #909399;
  font-size: 0.78rem;
  margin-bottom: 8px;
}
.range-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  color: #606266;
  font-size: 0.85rem;
}
.range-row__to {
  width: 100px;
}
.range-row__type {
  width: 80px;
}
.range-row__fee-label {
  color: #909399;
  cursor: help;
  border-bottom: 1px dashed #c0c4cc;
}
.preset-card__actions {
  margin-top: 10px;
}
.new-preset-btn {
  margin-top: 4px;
}
.history-entry {
  border-bottom: 1px solid #ebeef5;
  padding: 8px 0;
}
.history-diff {
  font-size: 0.8rem;
  color: #606266;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/commissionPresets.vue